<ng-container
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{ eventCategory: 'personal details form' }"
>
  <p *ngIf="vm.showRequiredFieldLegend" class="mb-6">
    {{ 'PERSONAL_DETAILS_FORM_REQUIRED_FIELD_LEGEND' | translate }}
  </p>
  <form
    *ngIf="vm.form as form"
    (submitted)="onFormSubmit($event)"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="form"
    class="personal-details-form"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-row *ngIf="!vm.cmsData.titleIdField.fieldHidden">
      <dgx-form-field
        [dgxFormField]="vm.cmsData.titleIdField"
        [dgxTestHook]="testHooks.Title"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="titleId"
      >
        <dgx-form-select
          [dgxQmSanitise]="'block'"
          [options]="vm.titleIdOptions"
        />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.firstNameField"
        [dgxTestHook]="testHooks.FirstName"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="firstName"
      >
        <dgx-form-text-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.lastNameField"
        [dgxTestHook]="testHooks.LastName"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="lastName"
      >
        <dgx-form-text-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.emailAddressField"
        [dgxTestHook]="testHooks.EmailAddressText"
        [optionalHidden]="true"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="emailAddress"
      >
        <dgx-form-email-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.telephoneNumberField"
        [dgxTestHook]="testHooks.TelephoneText"
        [optionalHidden]="true"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="telephoneNumber"
      >
        <dgx-form-telephone-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-fieldset [dgxFormFieldset]="vm.cmsData.addressFieldset">
      <dgx-form-row>
        <dgx-form-override-address
          [addressOverrideCheckboxLabel]="
            vm.cmsData.addressFieldset.addressOverrideCheckboxLabel
          "
          [addressOverrideText]="vm.cmsData.addressFieldset.addressOverrideText"
          [dgxQmSanitise]="'block'"
          [dgxTestHook]="testHooks.OverrideAddressSelectTypeAhead"
          formGroupName="address"
        />
      </dgx-form-row>
    </dgx-form-fieldset>

    <dgx-form-row>
      <dgx-form-submit-button
        [dgxGaClick]="{
          eventAction: 'continue',
          eventLabel: 'continue'
        }"
        [fill]="true"
        [iconAlign]="'left'"
        [iconName]="'shield-check'"
        class="mt-2"
      >
        {{ 'PERSONAL_DETAILS_FORM_SUBMIT_BUTTON' | translate }}
      </dgx-form-submit-button>
    </dgx-form-row>
  </form>
</ng-container>
